export const CertificateStatusEnum = {
    PENDING: "pending",
    ACTIVE: "active",
    REJECTED: "rejected",
    EXPIRED: "expired",
};
